import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CenterService } from "../shared/center.service";
import { PrivilegeService } from "../../../staff/Shared/privilege.service";
import { Document } from "./../../../helpers/Document";
import { Center } from "./../shared/center.model";

import { ConfirmationdialogService } from "../../../utility/shared/confirmationdialog.service";
import { ToasterserviceService } from "../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../utility/shared/toastpayload";

@Component({
  selector: 'app-centerlist',
  templateUrl: './centerlist.component.html',
  styleUrls: ['./centerlist.component.css']
})
export class CenterlistComponent implements OnInit {
  displayedColumns: string[] = ['Center', 'Code', 'Branch', 'Date', 'LocationName', 'LandMark', 'New'];
  ChequeList$ = [''];
  dataSource = new MatTableDataSource<any>();
  // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  IsAdd: boolean;
  IsEdit: boolean;
  IsDelete: boolean;
  IsView: boolean;
  IsPrint: boolean;
  toast: Toastpayload;

  constructor(private router: Router, private centerService: CenterService,
    private privilegeService: PrivilegeService,
    private toasterserviceService: ToasterserviceService,
    private confirmationdialogService: ConfirmationdialogService,) {

    // Getting page permissions
    const DocumentId = Document.Centre;
    this.PageSecurity(DocumentId);
  }

  ngOnInit() {

    // this.getCenterList();
    // this.dataSource.paginator = this.paginator;
  }

  ngAfterViewInit() {
    this.getCenterList();
    this.dataSource.paginator = this.paginator;
  }

  getCenterList() {
    this.centerService.FetchCenterList()
      .toPromise()
      .then(data => {
        // this.ChequeList$=data;
        this.dataSource.data = data;
      })
  }

  public AddNewCenter() {
    this.router.navigate(['/center']);
  }

  EditCenter(Center: any) {
    this.router.navigate(['/center', Center.Id]);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  PageSecurity(DocumentId: number) {

    this.privilegeService.GetPageSecuritybyRoleId(DocumentId).toPromise()
      .then(data => {
        if (data !== null) {
          this.IsAdd = data.IsAdd;
          this.IsEdit = data.IsEdit;
          this.IsDelete = data.IsDelete;
          this.IsView = data.IsView;
          this.IsPrint = true;
          console.log(this.IsView);
        }
      });
  }

  // Delete with Toastr messsage
  DeleteCenter(element: any) {

    this.toast = {
      message: "The centre have been deleted",
      title: 'Centre deletion',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    let title: string = "Confirmation";
    let message: string = "If you continue, the centre will be removed. Are you sure? ";
    let btnOkText: string = "Yes";
    let btnCancelText: string = 'No, Exit';

    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed =>
      // console.log('User confirmed:', confirmed)
      {
        if (confirmed == true) {
          // centrelink deletion
          this.IUDCentre(element);
        }
        else {

          // console.log(confirmed);
          this.toast.message = 'You are cancelled the centre deletion.!'
          this.toast.type = 'warning';
          this.toasterserviceService.showToast(this.toast);
        }
      });
  }

  // centre delete action
  IUDCentre(element: any) {

    this.centerService.selectedCenter = new Center;
    this.centerService.selectedCenter.Id = element.Id;  // CenterId
    this.centerService.selectedCenter.IsActive = 0;  // deactivate
    this.centerService.selectedCenter.Flag = 3; // deactivate Flag
    // IUD action
    this.centerService.IUDCenter(this.centerService.selectedCenter)
      .toPromise()
      .then(data => {
        this.router.navigate(['/centerlist']);
        // showing message:
        this.toasterserviceService.showToast(this.toast);
      })
  }

}
